/**
 * GET `admin/reports/clinics/:id/summary` — сводка отчётов выбранной
 * клиники за период: деньги, приёмы по статусам, пациенты, средний чек.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLINIC_SUMMARY} from '../mocks';
import {asNum, asObj, type Raw, toSom} from '../raw.utils';
import type {ClinicReportSummary, ReportPeriod} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClinicSummary = async (
  clinicId: string,
  period: ReportPeriod,
): Promise<ClinicReportSummary> => {
  if (!apiEnabled) {
    await sleep(300);
    return structuredClone(MOCK_CLINIC_SUMMARY);
  }

  const raw = await http<Raw>(`admin/reports/clinics/${encodeURIComponent(clinicId)}/summary`, {
    params: {period},
    skipCaseConversion: true,
  });
  const rev = asObj(raw.revenue);
  const app = asObj(raw.appointments);
  const pat = asObj(raw.patients);
  return {
    revenue: {
      income: toSom(rev.incomeTiyin),
      refund: toSom(rev.refundTiyin),
      net: toSom(rev.netTiyin),
    },
    appointments: {
      total: asNum(app.total),
      completed: asNum(app.completed),
      cancelled: asNum(app.cancelled),
      noShow: asNum(app.noShow),
    },
    patients: {total: asNum(pat.total), new: asNum(pat.new), returning: asNum(pat.returning)},
    charged: toSom(raw.chargedTiyin),
    discounts: toSom(raw.discountsTiyin),
    debt: toSom(raw.debtTiyin),
    averageCheck: toSom(raw.averageCheckTiyin),
  };
};
